import { useGetNotificationAttendanceSettingsQuery } from '@schooly/api';
import { useAuth } from '@schooly/components/authentication';

export const useAttendanceNotificationsEnabled = () => {
  const { schoolId = '' } = useAuth();

  const { data } = useGetNotificationAttendanceSettingsQuery({ schoolId }, { enabled: !!schoolId });

  return !!data?.attendance.enabled;
};
